import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { MATERIALS_FEATURE_KEY } from './keys';
import { materialsReducer } from './reducers/materials.reducer';
import { MaterialsEffects } from './effects/materials.effects';
import { MaterialsMaterialBridge } from './bridges/materials_material.bridge';

export function provideMaterialsStore(): EnvironmentProviders[] {
    return [provideState(MATERIALS_FEATURE_KEY, materialsReducer), provideEffects(MaterialsEffects, MaterialsMaterialBridge)];
}
